import { Block } from "@components/block";
import { Config, DoubleText, Table } from "@components/table";
import { TransactionsInfo } from "@components/transactions-info";
import styles from "./cash-register.module.scss";
import { useCashRegisters } from "@features/cash-registers";
import { useEffect } from "react";
import { CashRegister } from "@features/cash-registers/api";
import { usePagination } from "@hooks/use-pagination";
import { EllipsisText } from "@components/ellipsis-text";
import { formatUsdt, formatRubles } from "@helpers/format";

const config: Config<CashRegister> = [
  {
    label: "ID кассы",
    source: "id",
    renderComponent: (data) => (
      <EllipsisText text={data} copy startLength={10} />
    ),
  },
  { label: "Название кассы", source: "name" },
  {
    label: "Количество платежей за 24ч",
    source: "count_order_for_24_hours",
  },
  {
    label: "Доход",
    source: "ern",
    renderComponent: (data, item) => 
      <DoubleText text={formatRubles(item.ern_rub)} subText={formatUsdt(data)} />
      // formatUsdt(data),
  },
  {
    label: "Pay-Out",
    source: "pay_out_turnover_rub",
    renderComponent: (cell, data) => (
      <DoubleText text={formatRubles(cell)} subText={formatUsdt(data.pay_out_turnover_usdt)} />
    ),
  },
  {
    label: "Pay-In",
    source: "pay_in_turnover_rub",
    renderComponent: (cell, data) => (
      <DoubleText text={formatRubles(cell)} subText={formatUsdt(data.pay_in_turnover_usdt)} />
    ),
  },
];

export const CashRegistersPage = () => {
  const { state, getCashRegisters } = useCashRegisters();
  const { page, limit, setPage, setLimit } = usePagination();
  // const navigate = useNavigate();
  // const location = useLocation();

  useEffect(() => {
    getCashRegisters();
  }, [getCashRegisters]);

  // const navigateToOrders = (item: CashRegister) => {
  //   navigate(`${location.pathname}/../deals?cache=${item.id}`);
  // };

  return (
    <div>
      <TransactionsInfo
        profit={0}
        className={styles.chart}
        type="large"
        formatType="usdt"
      />
      <Block>
        <Table
          data={state.caches}
          loading={state.loading}
          config={config}
          title="Активные кассы"
          // onRowClick={navigateToOrders}
          setPage={setPage}
          setLimit={setLimit}
          page={page}
          limit={limit}
        />
      </Block>
    </div>
  );
};
